import React from 'react';
import { Home, Map, Fish, ShoppingBag, Users, Lock } from 'lucide-react';
import { Screen } from '../types/navigation';
import { useStore, isGameUnlocked } from '../lib/store';
interface BottomNavProps {
  currentScreen: Screen;
  onNavigate: (screen: Screen) => void;
}
export function BottomNav({
  currentScreen,
  onNavigate
}: BottomNavProps) {
  const {
    user
  } = useStore();
  // The fishing game is gated behind Fisher status.
  const gameLocked = !isGameUnlocked(user?.points || 0);
  // Only show nav on main app screens
  const mainScreens = ['feed', 'events', 'go-fish', 'catches', 'friends'];
  if (!mainScreens.includes(currentScreen)) return null;
  const navItems = [{
    id: 'feed',
    icon: Home,
    label: 'Feed'
  }, {
    id: 'events',
    icon: Map,
    label: 'Events'
  }, {
    id: 'go-fish',
    icon: Fish,
    label: 'Go Fish'
  }, {
    id: 'catches',
    icon: ShoppingBag,
    label: 'Catches'
  }, {
    id: 'friends',
    icon: Users,
    label: 'Friends'
  }];
  return <nav aria-label="Primary navigation" className="fixed bottom-4 left-1/2 -translate-x-1/2 w-[calc(100%-2rem)] max-w-lg rounded-full bg-white/95 backdrop-blur border border-white px-2 py-2 flex justify-between items-center z-50 shadow-[0_18px_40px_rgba(22,38,95,0.18)]" data-id="element-178" data-mp="90dx0i3xt3iz">
      {navItems.map(item => {
      const isActive = currentScreen === item.id;
      const showLock = item.id === 'go-fish' && gameLocked;
      return <button key={item.id} onClick={() => onNavigate(item.id as Screen)} className={`relative flex flex-col items-center justify-center min-w-0 flex-1 py-2 space-y-1 rounded-full transition-all ${isActive ? 'text-brand-purple bg-brand-lavender shadow-sm' : 'text-brand-navy/55 hover:text-brand-purple'}`} data-id="element-179" data-mp="wmao06aanmfn">
            <div className="relative" data-id="element-180" data-mp="1fdtpu9sl0ug3">
              <item.icon className={`w-6 h-6 ${isActive ? 'fill-current' : ''}`} strokeWidth={isActive ? 2.5 : 2} data-id="element-181" data-mp="1fevejh2itfga" />
              {showLock && <span className="absolute -top-1.5 -right-2 w-3.5 h-3.5 bg-gray-300 rounded-full flex items-center justify-center" data-id="element-182" data-mp="1kc0sg5hodko4">
                  <Lock className="w-2 h-2 text-gray-600" strokeWidth={3} data-id="element-183" data-mp="1fdz9dkk91lcn" />
                </span>}
            </div>
            <span className="text-[9px] sm:text-[10px] font-bold tracking-wide" data-id="element-184" data-mp="16ay39jvdvu8z">
              {item.label}
            </span>
          </button>;
    })}
    </nav>;
}